<div class="single-agent">
    <div class="sa-pic">
        <img [src]="Top_ag.img" alt="picture">
        <div class="hover-social">
            <a href="neds" class="twitter" title="{{ 'AGENT.SOCIAL_MEDIA' | translate }}"><i class="fa fa-twitter"></i></a>
            <a href="neds" class="instagram" title="{{ 'AGENT.SOCIAL_MEDIA' | translate }}"><i class="fa fa-instagram"></i></a>
            <a href="neds" class="facebook" title="{{ 'AGENT.SOCIAL_MEDIA' | translate }}"><i class="fa fa-facebook"></i></a>
        </div>
    </div>
    <h5>{{Top_ag.noms}}  <span>{{Top_ag.ville}}, {{Top_ag.zone}}</span></h5>
    <div class="agent-info">
        <div class="ai-text">
            <p><i class="fa fa-map-marker"></i> {{ 'AGENT.LOCATION' | translate }}: {{Top_ag.ville}}</p>
            <p><i class="fa fa-phone"></i> {{ 'AGENT.PHONE' | translate }}: {{Top_ag.telephone}}</p>
            <p><i class="fa fa-envelope"></i> {{ 'AGENT.EMAIL' | translate }}: {{Top_ag.email}}</p>
        </div>
        <a href="#" class="primary-btn">{{ 'AGENT.CONTACT' | translate }}</a>
    </div>
</div>
